import { render, staticRenderFns } from "./ReOrderList.vue?vue&type=template&id=69525a06&scoped=true&"
import script from "./ReOrderList.vue?vue&type=script&lang=js&"
export * from "./ReOrderList.vue?vue&type=script&lang=js&"
import style0 from "./ReOrderList.vue?vue&type=style&index=0&id=69525a06&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69525a06",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VBtn,VCard,VCardText,VChip,VIcon,VProgressLinear,VSkeletonLoader})
